import { render } from "./WnTablePages.vue?vue&type=template&id=16be60d5&scoped=true"
import script from "./WnTablePages.vue?vue&type=script&lang=js"
export * from "./WnTablePages.vue?vue&type=script&lang=js"

import "./WnTablePages.vue?vue&type=style&index=0&id=16be60d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16be60d5"]])

export default __exports__